import { ConnectedFocusError } from "focus-formik-error"
import { Form, Formik, FormikHelpers, FormikProps } from "formik"
import { ReactNode, Ref } from "react"
import styled from "styled-components"

type CommonFormProps<Schema, Values> = {
  validationSchema: Schema
  initialValues: Values
  render(props: FormikProps<Values>): ReactNode
  onSubmit(values: Values, actions: FormikHelpers<Values>): Promise<void>
  innerRef?: Ref<FormikProps<Values>>
}

const StyledForm = styled(Form)`
  ${(p) => p.theme.breakpoints.down("sm")} {
    width: 100%;
  }
`

function FormikForm<Schema, Values>({
  validationSchema,
  initialValues,
  render,
  onSubmit,
  innerRef,
}: CommonFormProps<Schema, Values>) {
  return (
    <Formik
      innerRef={innerRef}
      initialValues={initialValues}
      validationSchema={validationSchema}
      validateOnBlur={true}
      validateOnChange={true}
      onSubmit={async (values, actions) => {
        actions.setSubmitting(true)
        await onSubmit(values, actions)
        actions.setSubmitting(false)
      }}
    >
      {(formik) => (
        <StyledForm noValidate>
          <ConnectedFocusError />
          {render(formik)}
        </StyledForm>
      )}
    </Formik>
  )
}

export default FormikForm
